import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/pillarArticles';

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 text-center mb-4">
          {t('articlesH2')}
        </h2>
        <p className="text-center text-foreground-600 max-w-2xl mx-auto mb-12">
          {t('articlesSubtitle')}
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all hover:shadow-md"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors text-base leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <div className="flex items-center gap-1 text-sm font-medium text-primary-600">
                    <span>{t('readMore')}</span>
                    <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
                  </div>
                  <span className="text-xs text-foreground-400">{article.readTime} min</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('articlesCta')}
            <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
          </a>
        </div>
      </div>
    </section>
  );
}